import { jsx as _jsx } from "react/jsx-runtime";
const DownloadIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M5 20H19V18H5M19 9H15V3H9V9H5L12 16L19 9Z", fill: props.color }) })));
};
DownloadIcon.defaultProps = {
    color: 'white',
};
export default DownloadIcon;
